import React, { useEffect, useMemo, useState } from "react";
import TableRow from "./TableRow";
import TableHeaderCell from "./TableHeaderCell";
import TableTools from "./TableTools";
import "./Table.scss";

type TableProps = {
  rowData: Array<any>;
  columnsData: Array<any>;
  columnsActions?: Array<any>;
  showRowNumbers?: boolean;
  paginationOptions?: Array<number>;
};

const Table = ({ rowData, columnsData, showRowNumbers, paginationOptions = [100, 50, 25, 10] }: TableProps) => {
  const [preparedColumnsData, setPreparedColumnsData] = useState(columnsData);
  const [numberOfResults, setNumberOfResults] = useState(100);
  const [selectedPage, setSelectedPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    if (showRowNumbers) {
      setPreparedColumnsData([{ title: "nmb", label: "#" }, ...columnsData]);
    }
  }, [columnsData, showRowNumbers]);

  useEffect(() => {
    if (!rowData) return;
    setTotalPages(Math.ceil(searchFilteredData.length / numberOfResults));
  });

  const handleSearch = (term) => {
    setSelectedPage(1);
    setSearchTerm(term);
  };

  const searchFilteredData = useMemo(() => {
    return rowData.filter((obj) =>
      Object.keys(obj).some((key) => obj[key]?.toString().toLowerCase().includes(searchTerm.toLowerCase())),
    );
  }, [rowData, searchTerm]);

  const startSlicingValue = useMemo(() => {
    if (selectedPage === 1) return 0;
    else return (selectedPage - 1) * numberOfResults;
  }, [selectedPage, numberOfResults]);

  return (
    <>
      <TableTools
        paginationOptions={paginationOptions}
        handleSearch={handleSearch}
        numberOfResults={numberOfResults}
        setNumberOfResults={(e) => {
          setNumberOfResults(e);
          setSelectedPage(1);
        }}
        selectedPage={selectedPage}
        setSelectedPage={setSelectedPage}
        totalNumberOfPages={totalPages}
      />
      <table className="so-table">
        <thead>
          <tr>
            {preparedColumnsData &&
              preparedColumnsData.map((e) => (
                <TableHeaderCell key={e.title} style={{ width: e.width }}>
                  {e.label}
                </TableHeaderCell>
              ))}
          </tr>
        </thead>
        <tbody>
          {rowData &&
            searchFilteredData
              .slice(startSlicingValue, startSlicingValue + numberOfResults)
              .map((e, index) => (
                <TableRow key={index} data={{ nmb: index + 1, ...e }} columns={preparedColumnsData} />
              ))}
        </tbody>
      </table>
    </>
  );
};

export default Table;
